import { render, staticRenderFns } from "./Homestays.vue?vue&type=template&id=1ea7f8a2&scoped=true&"
import script from "./Homestays.vue?vue&type=script&lang=js&"
export * from "./Homestays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea7f8a2",
  null
  
)

export default component.exports